import { render, staticRenderFns } from "./FoldersView.vue?vue&type=template&id=4f3de861&scoped=true"
import script from "./FoldersView.vue?vue&type=script&lang=js"
export * from "./FoldersView.vue?vue&type=script&lang=js"
import style0 from "./FoldersView.vue?vue&type=style&index=0&id=4f3de861&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f3de861",
  null
  
)

export default component.exports